import { createNamespacedHelpers } from "vuex-composition-helpers";
import * as AccountPlanStoreActions from "@Broker/@Modules/account-plan/store/account-plan-actions";
const {
  useState,
  useActions
} = createNamespacedHelpers("AccountPlanStore");
export const useAccountPlantUsageSync = () => {
  const {
    currentPagePlan
  } = useState(["currentPagePlan"]);
  const {
    LOAD_PLAN_LIMIT
  } = useActions([AccountPlanStoreActions.LOAD_PLAN_LIMIT]);
  const syncAccountPlanUsage = async (callback, pagePlan) => {
    await callback();
    const pagePlanToUse = pagePlan || currentPagePlan.value;
    await LOAD_PLAN_LIMIT(pagePlanToUse);
  };
  return {
    syncAccountPlanUsage
  };
};